<template>
    <table class="table table-hover">
        <thead>
        <tr>
            <th v-if="showId">{{ $t('components.order.id') }}</th>
            <th>{{ $t('common.time.date') }}</th>
            <th v-if="showClient">{{ $t('common.client') }}</th>
            <th>{{ $t('components.order.description') }}</th>
            <th>{{ $t('common.state') }}</th>
            <th>{{ $t('common.payment') }}</th>
            <th>{{ $t('components.order.amount') }}</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <OrderRow
            :order="order"
            v-for="order in orders"
            v-bind:key="order.id"
            :show-client="showClient"
            :show-id="showId"
            @show-receipt="showReceipt"
        ></OrderRow>
        </tbody>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
    </table>
</template>

<script>

import OrderRow from "./OrderRow";
import SpinnerLoader from "../common/SpinnerLoader";
import {getOrderDetail} from "../../api";

export default {
    name: "AppointmentsTable",
    components: {OrderRow, SpinnerLoader},
    data: () => {
        return {
            loading: false
        }
    },
    props: {
        orders: {
            type: Array,
            required: true
        },
        showId: {
            type: Boolean,
            default: true
        },
        showClient: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        async showReceipt(order) {
            this.loading = true;
            try {
                let orderDetail = await getOrderDetail(order.id);
                this.$emit('show-receipt', orderDetail);
                this.loading = false;
            } catch (e) {
                console.log(e);
                this.$emit('show-receipt', order);
                this.loading = false;
            }

        }
    }
}
</script>

<style scoped>

</style>
